import { logEvent, login, sourceMenuManagement } from "../../basic/path";
import RequestModel from "../../basic/requestConfig";

export default {
  getButtonPermission(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: login.getButtonPermission,
          data: query.data? query.data : {},
          params: query.params? query.params : {},
        }),
        request = requestModel.defaultConfig(); 
        vue.axios(request).then(function (result) {
          resolve(result);
        })
    });
  },
  login(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: login.loginApi,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  isLoginAnother(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: login.isLoginAnother,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  singleSignOn(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: login.singleSignOn,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  getUserMenu(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: login.getMenu,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },

  updUserStyle(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "post",
          url: login.updUserStyle,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
          },
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  changeLanguage(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: "/api/userManagement/changeLanguage",
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
  loginOutEvent(vue, query) {
    return new Promise((resolve, reject) => {
      let requestModel = new RequestModel({
          method: "get",
          url: login.loginOutApi,
          data: query.data ? query.data : {},
          params: query.params ? query.params : {},
        }),
        request = requestModel.defaultConfig();
      vue.axios(request).then(function (result) {
        resolve(result);
      });
    });
  },
};
